import { useInfiniteQuery } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { InfiniteQueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';
import { Filter } from '@/src/util/filters';

import { sanitizeFilter } from './getFiles';

import { PROJECT_BASE_URL } from '../../api/config';
import { LibraryItemDTO } from '../types';

const url = `${PROJECT_BASE_URL}/library`;

export type GetRootFilesResponse = {
  status: boolean;
  data: LibraryItemDTO[];
};

export type GetRootFilesDTO = {
  projectId: number;
  page: number;
  filter: Filter[];
};

export type GetRootFilesParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getRootFilesQueryKey = {
  list: ['getRootFiles'] as const,
};

const LIST_LIMIT = 20;

export const getRootFiles = ({
  projectId,
  page,
  filter,
}: GetRootFilesDTO): Promise<GetRootFilesResponse> => {
  const URL = generateRoutePath(url, { projectId });
  const sanitized = filter ? sanitizeFilter(filter) : [];
  const filterParams =
    Array.isArray(sanitized) && sanitized.length > 0 ? { filter: JSON.stringify(sanitized) } : {};

  const params: GetRootFilesParams = {
    page,
    limit: LIST_LIMIT,
    ...filterParams,
  };

  return axios.get(URL, { params });
};
type QueryFnType = typeof getRootFiles;

type UseGetRootFilesOptions = {
  projectId: number;
  filter: Filter[];
  config?: InfiniteQueryConfig<QueryFnType>;
};

export const useGetRootFiles = ({ projectId, filter, config }: UseGetRootFilesOptions) => {
  return useInfiniteQuery({
    queryKey: [...getRootFilesQueryKey.list, projectId, filter],
    queryFn: ({ pageParam = 1 }) => getRootFiles({ projectId, page: pageParam, filter }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.data.length === LIST_LIMIT ? allPages.length + 1 : undefined;
    },
    // staleTime: Infinity,
    // cacheTime: 0,
    ...config,
  });
};
